"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const query_string_1 = require("query-string");
const ApiClient_1 = __importDefault(require("./ApiClient"));
const frontendApps_1 = require("./frontendApps");
const getAppHostConfig_1 = __importDefault(require("./getAppHostConfig"));
const { BASE_HOST } = getAppHostConfig_1.default();
class AtmsApiClient extends ApiClient_1.default {
    httpGet(path, defaultValue = {}, options) {
        return super
            .httpGet(path, options)
            .then(value => {
            if (Object.entries(value).length === 0 && value.constructor === Object) {
                return defaultValue;
            }
            return value;
        })
            .catch((e) => {
            // Implement 'Carlton Dance' for sysadmins by adding special handling for AuthSwitchNeededForAccess exceptions
            let redirected = false;
            e.details &&
                e.details.errors &&
                e.details.errors.forEach((err) => {
                    var _a;
                    if (((_a = err === null || err === void 0 ? void 0 : err.details) === null || _a === void 0 ? void 0 : _a.errorCode) === 'AuthSwitchNeededForAccess') {
                        const redirectQuery = {
                            organization: err.details.organization,
                            backUrl: window.location.pathname + window.location.search,
                        };
                        window.location.href = `/web/organization/switchToOrg?${query_string_1.stringify(redirectQuery)}`;
                        redirected = true;
                    }
                });
            if (!redirected) {
                throw e;
            }
        });
    }
}
let hostname;
// if we're not on atms-web-ui and we're on a non-standard port or hostname, that means we're
// developing another *-web-ui app locally and need to explicitly hit atms-web-ui (and its
// cloudfront emulating proxy) so that the request is correctly routed to the right origin (web,
// tickets-service, etc)
if (!frontendApps_1.isOnAtmsWebUi() && (location.port || location.host != BASE_HOST)) {
    hostname = BASE_HOST;
}
exports.default = new AtmsApiClient(hostname);
//# sourceMappingURL=AtmsApiClient.js.map